module.exports = __webpack_public_path__ + "img/client-logo-1.6dda7064.png";